import {Tag } from "antd";
import React from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";

const DetailStatut = ({ modal, setModal, toggle, selectedCatalog }) => {
  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{maxWidth:"700px"}}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Détail du catalogue <Tag color="cyan">{selectedCatalog?.name}</Tag> de la catégory <Tag color="warning">{selectedCatalog?.category}</Tag>
      </ModalHeader>
      <Form>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Nom Catalogue</label>
                <input disabled className="form-control" value={selectedCatalog?.name || "-"}/>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <label htmlFor="category" className="form-label">Catégorie</label>
                <input disabled id="category" className="form-control" value={selectedCatalog?.category || "-"}  />
              </div>
            </Col>
            {(selectedCatalog?.category === 'inspectionCible' || selectedCatalog?.category === 'inspectionComplete' || selectedCatalog?.category === 'Incident') && (
                <>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label htmlFor="type" className="form-label">Type</label>
                      <input disabled id="type" className="form-control" value={selectedCatalog?.type || "-"}  />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label htmlFor="question" className="form-label">Questions</label>
                      <input disabled id="question" className="form-control" value={selectedCatalog?.question || "-"}  />
                    </div>
                  </Col>
              </>
            )}
            
            <Col lg={12}>
              <div className="mb-3">
                <label htmlFor="description" className="form-label">Description</label>
                <textarea disabled id="description" className="form-control" value={selectedCatalog?.description  || "-"}  />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => setModal(false)}>
            Fermer
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default DetailStatut;
